import React from 'react';
import Label from 'components/form/Label/Label';
import { commafy } from 'helpers/number';
import { Button } from 'components/form/Button';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import './StandardPersonalLoanOfferRedesignExp.scss';
import { getSimplifiedDate } from 'helpers/dateHelper';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';

const StandardPersonalLoanOfferRedesignExp = props => {
  const {
    offerMetadata,
    offerImageLinkUrlProxy,
    seenPixel,
    quantityOfOffers,
    toPersonalLoanPage,
    clickApplyHandler,
    clickDetailsHandler,
  } = props;
  const {
    dueDate,
    termMonths,
    monthlyPayment,
    loanAmount,
    apr,
    totalCost,
    name,
  } = offerMetadata;
  return (
    <FlexContainer column justifyCenter alignItemsCenter className="format100">
      <FlexContainer
        column
        className="flex-container personalLoanOffer grayShadow10 margt12 border-rad8px pad16 m-padLR0 bgWhite format100"
      >
        {seenPixel}
        <FlexContainer className="m-padLR16">
          <FlexContainer
            column
            justifyCenter
            className="padTB8 padLR16 border-rad8px blueBG format100"
          >
            <Label className="bold text-14 lineHeight140">
              {' '}
              Still interested?{' '}
            </Label>
            <Label className="text-12 lineHeight140">
              {' '}
              Claim your loan offer before your rate{' '}
              <span className="bold">
                {' '}
                expires on {getSimplifiedDate(dueDate)}.{' '}
              </span>
            </Label>
          </FlexContainer>
        </FlexContainer>
        <FlexContainer
          alignItemsCenter
          className="margT18 m-margT10 m-format100 m-justify-center"
        >
          <Label className="text-12 bold padTB2 padLR12 border-rad16px greenBG">
            LOWEST APR
          </Label>
        </FlexContainer>
        <FlexContainer
          alignItemsCenter
          justifyBetween
          className="format100 margT10 m-hide t-hide"
        >
          <FlexContainer alignItemsCenter justifyCenter className="format33">
            <img
              alt="personal loan"
              src={offerImageLinkUrlProxy}
              className="pointer imgCardSize align-self-center"
            />
          </FlexContainer>
          <FlexContainer
            column
            alignItemsCenter
            justifyBetween
            className="format33 text-center"
          >
            <Label className="text-14">{termMonths} monthly payments</Label>
            <Label className="text-36">${commafy(monthlyPayment)}</Label>
          </FlexContainer>
          <FlexContainer
            column
            alignItemsCenter
            justifyBetween
            className="format33 text-center pad10"
          >
            <FlexContainer
              className={'flex-column align-self-center margt10 format100'}
            >
              <Button
                mrphType="primary"
                onClick={e =>
                  clickApplyHandler(e, {
                    event: CLICK,
                    clickType: 'Click Apply',
                  })
                }
                className="border-rad100px"
                fullWidth
              >
                <Label
                  color="primary_cta_text_light"
                  className={'text-14'}
                  tabIndex="-1"
                >
                  Get this offer
                </Label>
              </Button>
            </FlexContainer>
            <Label className="text-12 margT10">
              on {name}'s secure website
            </Label>
          </FlexContainer>
        </FlexContainer>
        <FlexContainer
          alignItemsCenter
          justifyCenter
          className="margT20 m-hide t-hide"
        >
          <FlexContainer
            column
            alignItemsCenter
            justifyBetween
            className="format25 lineRight"
          >
            <Label className="text-12">Loan Amount</Label>
            <Label className="bold">${commafy(loanAmount)}</Label>
          </FlexContainer>
          <FlexContainer
            column
            alignItemsCenter
            justifyBetween
            className="format25 lineRight"
          >
            <Label className="text-12">APR</Label>
            <Label className="bold">{apr}%</Label>
          </FlexContainer>
          <FlexContainer
            column
            alignItemsCenter
            justifyBetween
            className="format25 lineRight"
          >
            <Label className="text-12">Est. Interest/Fees*</Label>
            <Label className="bold">${commafy(totalCost)}</Label>
          </FlexContainer>
          <FlexContainer
            column
            alignItemsCenter
            justifyBetween
            className="format25"
          >
            <Label className="text-12">Total Loan Amount</Label>
            <Label className="bold">${commafy(loanAmount + totalCost)}</Label>
          </FlexContainer>
        </FlexContainer>
        <FlexContainer
          justifyCenter
          alignItemsCenter
          className="format100 m-hide t-hide"
        >
          <Label
            className="text-12 text-center link format100 margT20 notBold"
            onClick={clickDetailsHandler}
          >
            See details, rates, and fees
          </Label>
        </FlexContainer>
        {/* Mobile */}
        <FlexContainer
          column
          alignItemsCenter
          justifyBetween
          className="format100 margT10 d-hide"
        >
          <FlexContainer
            column
            alignItemsCenter
            justifyCenter
            className="format100 text-center"
          >
            <Label className="text-14">{termMonths} monthly payments</Label>
            <Label className="text-36">${commafy(monthlyPayment)}</Label>
          </FlexContainer>
          <FlexContainer
            alignItemsCenter
            justifyCenter
            className="format100 m-margT16"
          >
            <img
              alt="personal loan"
              src={offerImageLinkUrlProxy}
              className="pointer imgCardSize align-self-center"
            />
          </FlexContainer>
          <FlexContainer
            alignItemsCenter
            justifyCenter
            className="margT20 format100"
          >
            <FlexContainer
              column
              alignItemsCenter
              justifyBetween
              className="format50 lineRight lineTop padTB14"
            >
              <Label className="text-12">Loan Amount</Label>
              <Label className="bold">${commafy(loanAmount)}</Label>
            </FlexContainer>
            <FlexContainer
              column
              alignItemsCenter
              justifyBetween
              className="format50 lineTop padTB14"
            >
              <Label className="text-12">APR</Label>
              <Label className="bold">{apr}%</Label>
            </FlexContainer>
          </FlexContainer>
          <FlexContainer alignItemsCenter justifyCenter className="format100">
            <FlexContainer
              column
              alignItemsCenter
              justifyBetween
              className="format50 lineRight lineTop lineBottom padTB14"
            >
              <Label className="text-12">Est. Interest/Fees*</Label>
              <Label className="bold">${commafy(totalCost)}</Label>
            </FlexContainer>
            <FlexContainer
              column
              alignItemsCenter
              justifyBetween
              className="format50 lineTop lineBottom padTB14"
            >
              <Label className="text-12">Total Loan Amount</Label>
              <Label className="bold">${commafy(loanAmount + totalCost)}</Label>
            </FlexContainer>
          </FlexContainer>
          <FlexContainer
            className={
              'flex-column align-self-center margt10 m-margt26 format100 m-padLR32'
            }
          >
            <Button
              mrphType="primary"
              onClick={e =>
                clickApplyHandler(e, { event: CLICK, clickType: 'Click Apply' })
              }
              className="border-rad100px"
              fullWidth
            >
              <Label
                color="primary_cta_text_light"
                className={'text-14'}
                tabIndex="-1"
              >
                Get this offer
              </Label>
            </Button>
          </FlexContainer>
          <Label className="text-12 margT10">on {name}'s secure website</Label>
          <Label
            className="text-12 text-center link format100 margT20 m-margT10 notBold"
            onClick={clickDetailsHandler}
          >
            See details, rates, and fees
          </Label>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer
        alignItemsCenter
        justifyBetween
        className="m-flex-column format100 padTB16 padR16"
      >
        <Label className="text-16 m-text-14 bold padR50 m-padLR0 m-padT10 m-padB16">
          You are pre-qualified for {quantityOfOffers} more offers with monthly
          payments as low as ${commafy(monthlyPayment)}
        </Label>
        <FlexContainer
          className={'flex-column align-self-center pad10 format33 m-format80'}
        >
          <Button
            mrphType="primary"
            onClick={toPersonalLoanPage}
            className="border-rad100px"
            fullWidth
          >
            <Label
              color="primary_cta_text_light"
              className={'text-14'}
              tabIndex="-1"
            >
              See {quantityOfOffers} more offers
            </Label>
          </Button>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export { StandardPersonalLoanOfferRedesignExp };
